









































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Account, AccountAgent } from "@/models/account";
import loader from "@/components/loader.vue";
import CartItem from "./CartItem.vue";
import accountsApi from "@/services/accounts";
import billingApi from "@/services/billing";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Getter, Action } from "vuex-class";
import { Order } from "@/models/order";
import { Package } from "../../models/package";
import moment from "moment";
import { ServiceMatrix } from "@/models/serviceMatrix";
import { Warehouse } from "@/models/warehouse";
import CartBundleItem from "./CartBundleItem.vue";

@Component({
  components: {
    loader,
    CartItem,
    CartBundleItem
  }
})
export default class Cart extends Vue {
  public downloadQuoteLoading = false;

  private get OnceOff() {
    if (!this.order || !this.order.packages) {
      return 0;
    }

    let total = 0;
    this.order.packages.map(
      (p: Package) =>
      (total +=
        p.interval === "once" || p.category === "custom" ? p.total : 0)
    );
    return total;
  }

  private get SubscriptionsDueNow() {
    if (!this.order || !this.order.packages) {
      return 0;
    }

    let total = 0;
    this.order.packages.map((p: Package) => (total += p.is_plan ? p.total : 0));
    return total;
  }

  private get Monthly() {
    if (!this.order || !this.order.packages) {
      return 0;
    }

    let total = 0;
    this.order.packages.map(
      (p: Package) =>
      (total +=
        p.interval === "month" ? p.price * (1 + p.tax_rate / 100) * p.qty : 0)
    );
    return total;
  }

  private get Yearly() {
    if (!this.order || !this.order.packages) {
      return 0;
    }

    let total = 0;
    this.order.packages.map(
      (p: Package) =>
      (total +=
        p.interval === "year" ? p.price * (1 + p.tax_rate / 100) * p.qty : 0)
    );
    return total;
  }

  private get Vat() {
    if (!this.order) {
      return 0;
    }
    return this.order.total_tax;
  }

  private get Discount() {
    if (!this.order) {
      return 0;
    }
    return this.order.discount;
  }

  private get Total() {
    if (!this.order) {
      return 0;
    }
    return this.order.total;
  }

  private get TotalEstimated() {
    if (!this.order) {
      return 0;
    }
    return this.order.total_estimated;
  }

  private get EstimatedCurrency() {
    if (!this.order) {
      return "";
    }
    if (
      this.order.currency_estimated !== "" &&
      this.order.currency_estimated !== this.order.currency
    ) {
      return this.order.currency_estimated;
    }
  }

  @Getter("serviceMatrix") serviceMatrix!: ServiceMatrix[];
  get services() {
    return this.serviceMatrix.find(
      (mtix) => mtix.id === this.order!.service_matrix_id
    ) || { warehouse_id: 0 };
  }

  @Getter("warehouses") warehouses!: Warehouse[];
  get warehouse() {
    if (!this.order) return { id: 0 };
    return (
      this.warehouses.find(
        (wh) => wh.id === this.services!.warehouse_id
      ) || { id: 0 }
    );
  }

  @Prop({ required: true }) private order!: Order;
  @Getter("salesConsultants") private salesConsultants!: AccountAgent[];
  get activeAgents() {
    return this.salesConsultants.filter((a) => a.active || this.order.sales_agent_id == a.id)
  }

  get currentSalesAgentActive() {
    const agent = this.salesConsultants.find((a) => this.order.sales_agent_id == a.id);
    if (!agent || !agent.active) return false;
    return true;
  }

  private loading = false;

  private setSalesConsultant(id: number) {
    this.$emit("update", { sales_agent_id: id || 0 }, true);
  }

  private inc(code: string, discountRate: number, bundleId?: number) {
    this.$emit("updatePackageQty", code, false, 1, false, discountRate, bundleId);
  }
  private dec(code: string, discountRate: number, bundleId?: number) {
    this.$emit("updatePackageQty", code, false, false, 1, discountRate, bundleId);
  }
  private consultantName(acc: AccountAgent) {
    if (!acc.active) return acc.first_name + " " + acc.last_name + " (inactive)";
    return acc.first_name + " " + acc.last_name;
  }

  private byGroup(category: string, includeBundleItems?: boolean) {
    if (!this.order) {
      return [];
    }
    return this.order.packages.filter((p) => p.category === category && (includeBundleItems || !p.bundle_id));
  }

  private get bundles() {
    if (!this.order) {
      return [];
    }
    // const bundles = this.order.packages.reduce((val: { [key: string]: BundleWithQTY }, p) => {
    const bundles = this.order.packages.reduce((val: any, p) => {
      if(!p.bundle_id) return val;
      const v = val[`${p.bundle_id}-${p.discount_rate}`] || [];
      v.push(p);
      val[`${p.bundle_id}-${p.discount_rate}`] = v;
      return val;
    },
      {}
    );
    return Object.keys(bundles).reduce((res: any, b) => {
      res.push(bundles[b]);
      return res;
    }, [])
  }

  private formatDate(date: any) {
    if (!date) {
      return null;
    }

    const [year, month, day] = date.split("-");
    return;
  }

  private async downloadQuote() {
    if (!this.order) {
      return;
    }
    this.downloadQuoteLoading = true;

    await this.$emit("update", {}, true);

    setTimeout(async () => {
      if (!this.order) {
        return;
      }
      await billingApi.downloadOrderQuote(this.order.id || 0);
      this.downloadQuoteLoading = false;
    }, 1000);
  }
}
